import httpbaseURL from '../../../../modules/Inventory/common/axios';
class AsseAssignmentServices {
    createdata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/AssetAssignment/Create", doc)
    }
    reassignData(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/AssetAssignment/ReAssign", doc)
    }
    updatedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/AssetAssignment/Update", doc)
    }
    getdata() {
        return httpbaseURL.httpMSInventoryUrl.get("/AssetAssignment/ListAssign")
    }
    getAssetOutsidePremisesList() {
        return httpbaseURL.httpMSInventoryUrl.get("/AssetAssignment/AssetOutsidePremisesList")
    }
    getAssetOutsidePremisesListByAssetId(assetId: any) {
        return httpbaseURL.httpMSInventoryUrl.get("/AssetAssignment/AssetOutsidePremisesListByAssetId?assetId=" + assetId)
    }


    getDashboarddata(HId, BId, SId) {
        return httpbaseURL.httpMSInventoryUrl.get("/AssetAssignment/ListAssignDashboard?HospitalId=" + HId + "&BranchId=" + BId + "&StoreId=" + SId)
    }
    getfindonedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.get("/AssetAssignment/Get?id=" + doc)
    }

    deletedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.delete("/AssetAssignment/Delete?ID=" + doc)
    }
    updateextendeddate(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/AssetAssignment/ExtendReturnDate", doc)
    }
}
export default new AsseAssignmentServices()